import React from 'react';

/**
 * Newton Health Connect logo — Network Hub variant.
 * Props:
 *   size     — icon size in px (default 32)
 *   showText — render "NewtonHealth Connect" text (default true)
 *   textOverride — optional text to render instead of default
 *   light    — use white text (for dark backgrounds, default false)
 *   style    — container style overrides
 */
export default function NHLogo({ size = 32, showText = true, textOverride, light = false, style }) {
  // Scale gradient IDs to avoid clashes when multiple logos on page
  const uid = `nh-${size}`;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.3, ...style }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id={`${uid}-g`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#EC4899" />
          </linearGradient>
        </defs>

        {/* Connection lines */}
        <line x1="100" y1="100" x2="100" y2="30" stroke="#E5E7EB" strokeWidth="4" />
        <line x1="100" y1="100" x2="170" y2="65" stroke="#E5E7EB" strokeWidth="4" />
        <line x1="100" y1="100" x2="170" y2="135" stroke="#E5E7EB" strokeWidth="4" />
        <line x1="100" y1="100" x2="100" y2="170" stroke="#E5E7EB" strokeWidth="4" />
        <line x1="100" y1="100" x2="30" y2="135" stroke="#E5E7EB" strokeWidth="4" />
        <line x1="100" y1="100" x2="30" y2="65" stroke="#E5E7EB" strokeWidth="4" />

        {/* Outer nodes */}
        <circle cx="100" cy="30" r="18" fill="#3B82F6" />
        <circle cx="170" cy="65" r="18" fill="#10B981" />
        <circle cx="170" cy="135" r="18" fill="#8B5CF6" />
        <circle cx="100" cy="170" r="18" fill="#EC4899" />
        <circle cx="30" cy="135" r="18" fill="#F59E0B" />
        <circle cx="30" cy="65" r="18" fill="#06B6D4" />

        {/* Center hub with medical cross */}
        <circle cx="100" cy="100" r="35" fill={`url(#${uid}-g)`} />
        <rect x="96" y="86" width="8" height="28" rx="2" fill="white" />
        <rect x="86" y="96" width="28" height="8" rx="2" fill="white" />
      </svg>

      {showText && (
        <span style={{
          display: 'flex',
          flexDirection: 'column',
          lineHeight: 1.15,
          whiteSpace: 'nowrap',
        }}>
          <span style={{
            fontSize: size * 0.55,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: light ? '#ffffff' : '#111827',
          }}>
            {textOverride || (
              <>
                Newton
                <span style={{
                  color: light ? '#c4b5fd' : '#7C3AED',
                  fontWeight: 700,
                }}>Health</span>
              </>
            )}
          </span>
          {!textOverride && (
            <span style={{
              fontSize: size * 0.32,
              fontWeight: 600,
              color: light ? '#a78bfa' : '#6D28D9',
              letterSpacing: '0.04em',
            }}>
              Connect
            </span>
          )}
        </span>
      )}
    </span>
  );
}
